import setBrands from './setBrands'
import setCategories from './setCategories'
import setSearch from './setSearch'
import setPrice from './setPrice'
import removeBrands from './removeBrands'
import removeCategories from './removeCategories'
import removePrice from './removePrice'
import removeProductFilters from './removeProductFilters'

export default {
  setBrands,
  setCategories,
  setSearch,
  setPrice,
  removeBrands,
  removeCategories,
  removePrice,
  removeProductFilters,
}
